import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus, PlusCircle, Trash, Trash2, LucideIcon } from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  'fa-plus': Plus,
  'fa-plus-circle': PlusCircle,
  'fa-trash': Trash,
  'fa-trash-circle': Trash2,
};

interface HoverButtonProps {
  onClick: () => void;
  text?: string;
  normalIcon?: string;
  hoveredIcon?: string;
  btnClass?: string;
}

function HoverButton({ onClick, text, normalIcon, hoveredIcon, btnClass }: HoverButtonProps) {
  const [hovered, setHovered] = useState(false);
  const iconKey = hovered ? hoveredIcon : normalIcon;
  const Icon = (iconKey ? iconMap[iconKey] : undefined) || Plus;
  const variant = btnClass === 'btn-danger' ? 'destructive' : 'default';

  return (
    <Button
      type="button"
      variant={variant}
      size="sm"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Icon className="h-4 w-4 mr-1" />
      {text}
    </Button>
  );
}

export default HoverButton;
